import { AlertType } from '~/types';
import { HeaderSortOptions } from '~/types/misc';
import { dateDisplay } from '~/utils/dates/dateDisplay';
import { INSTALLED_ON_COL, STANDARD_COLS } from '~/utils/genericTableColumns';
import { alertableStatusDisplay } from '~/utils/helpers';
import { addAttributeDateDisplays, addBaseProperties, addEvaEvents, addFemurComments, addInstalledChildren, addInstalledOnIcon, addLaunchReturn, addStatusDateDisplays } from '~/utils/mappers';
import { ACTIVITY_TABLE_HEADERS } from './activities';
export const WLVTA_TABLE_HEADERS = [
    ...STANDARD_COLS,
    INSTALLED_ON_COL,
    {
        text: 'Expiry',
        value: '_piaExpirationDueDate',
        sortable: true,
        noWrap: true,
        noEscape: true,
        headerSortType: HeaderSortOptions.DATE
    }
];
export const ACTIVITY_WLVTA_TABLE_HEADERS = [...ACTIVITY_TABLE_HEADERS];
export const transformWlvta = (items) => {
    return items
        .map(addAttributeDateDisplays)
        .map(addBaseProperties)
        .map(addEvaEvents)
        .map(addFemurComments)
        .map(addLaunchReturn)
        .map(addInstalledOnIcon)
        .map(addInstalledChildren)
        .map(addStatusDateDisplays)
        .map((item) => {
        const status = item?.status;
        // expiration date
        let _piaExpirationDueDate = dateDisplay(status.wlvtaRemoveReplaceDueDate?.value);
        _piaExpirationDueDate = alertableStatusDisplay(status.wlvtaRemoveReplaceDueDate, _piaExpirationDueDate);
        // alerts based on status
        // ignoring SOP check out due date
        const alerts = [status?.wlvtaRemoveReplaceDueDate?.alertType];
        const redAlert = alerts.find((alert) => alert === AlertType.ALERT);
        const orangeAlert = alerts.find((alert) => alert === AlertType.WARNING);
        const rowClass = redAlert ? 'red lighten-3' : orangeAlert ? 'orange lighten-3' : '';
        const _item = Object.assign({}, item, {
            _piaExpirationDueDate,
            rowClass
        });
        return _item;
    });
};
